import { connect } from 'react-redux';
import CompanyInfo from "../../../../components/admin/riaContacts/acordionSections/CompanyInfo";

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
  }
}

const CompanyInfoContainer = connect(mapStateToProps, {})(CompanyInfo)

export default CompanyInfoContainer;